<div class="row">
    <div class="col-md-6 card-padding" *ngFor="let newAsset of newestAssetArray">
        <div class="col-sm card shadow p-3 mb-5 bg-body">
            <div class="card-body">
                <div class="card-right-padding">
                    <h5 class="card-title" title="{{newAsset.Asset_Name}}">{{newAsset.Asset_Name}}</h5>
                    <p class="card-text new-asset-description" title="{{newAsset.Asset_Description}}">{{newAsset.Asset_Description}}</p>
                </div>
                <a (click)="onViewClick(newAsset.Asset_Id)" class="view-btn">View</a>
            </div>
        </div>
    </div>
<div>
    